import { render, staticRenderFns } from "./usefull-links-create.vue?vue&type=template&id=2d56681d&scoped=true&"
import script from "./usefull-links-create.vue?vue&type=script&lang=js&"
export * from "./usefull-links-create.vue?vue&type=script&lang=js&"
import style0 from "./usefull-links-create.vue?vue&type=style&index=0&id=2d56681d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d56681d",
  null
  
)

export default component.exports